// v0.6.12 A2-192 — who the buyer is, in one line, for the audit
// surfaces.
//
// THE OPERATOR'S POINT, and the reason this is three states and not
// two: a blank cell cannot tell you whether the buyer HAS no VAT
// number because they are a private individual — which is normal and
// correct — or because one is MISSING on a business sale, which is a
// flagged condition the engine holds the row for. Showing the words
// removes that ambiguity without the reader having to cross-reference
// the flag list.
//
// Deliberately NOT the client's own registration: that is a per-return
// fact and already appears once on the Calc Parameters tab, rather
// than being repeated on every row.
//
// Keep the wording in step with the XLSX VAT Treatment tab —
// test_v0612_a2_192 asserts the two surfaces say the same words.

export const BUYER_PRIVATE_INDIVIDUAL = "Private individual";
export const BUYER_VAT_NUMBER_ABSENT = "No VAT number";

/**
 * @param {{buyer_vat_number?: string|null, is_b2b?: boolean}} tx
 * @returns {{text: string, kind: "number"|"private"|"absent"}}
 */
export const buyerIdentity = (tx) => {
  const num = (tx?.buyer_vat_number || "").trim();
  if (num) return { text: num, kind: "number" };
  if (tx?.is_b2b) return { text: BUYER_VAT_NUMBER_ABSENT, kind: "absent" };
  return { text: BUYER_PRIVATE_INDIVIDUAL, kind: "private" };
};

export default buyerIdentity;
